<template>
  <footer>
    <section class="content">
      <div class="top">
        <div class="left">
          <span class="title">发心利他，创造共享</span>
          <div class="nav-box">
            <div v-for="(item, index) in navList" :key="index" class="nav-item">
              <span class="nav-title">{{ item.name }}</span>
              <div class="nav-child">
                <span v-for="(child, idx) in item.children" :key="idx" class="nav-child-item cursor-pointer"
                  @click="toPage(child.path)">{{ child.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-for="qrcode in codeList" :key="qrcode.src" class="code-item">
            <img class="img-box" width="85" :src="qrcode.src" />
            <div class="code-text">{{ qrcode.text }}</div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <span>© 2026 中知数通（北京）信息技术有限公司 版权所有，翻印必究</span>
        <span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;备案号：</span>
        <span class='cursor-pointer' @click="jumpLink('icp')">京ICP备2021036050号</span>
        <span>&nbsp;|&nbsp;</span>
        <span class='cursor-pointer' @click="jumpLink('gongan')">京公网安备 11010202010013号</span>
      </div>
    </section>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      codeList: [
        { src: 'https://images.zzt.com.cn/ox/2022/04/26/concatc2.png', text: '扫码联系客服' },
        { src: 'https://images.zzt.com.cn/ox/2022/12/06/weixin.png', text: '微信公众号' }
      ],
      navList: [
        {
          name: 'AI应用',
          children: [
            { path: '/aerialView', name: '瞰见' },
            { path: '/patE', name: '深眸' },
            { path: '/goldSight', name: '点睛投研' }
          ]
        },
        {
          name: '数据与模型',
          children: [
            { path: '/bigData', name: '数据接口' },
            { path: '/intelligentModel', name: '模型服务' }
          ]
        },
        {
          name: '关于我们',
          children: [
            { path: '/aboutUs', name: '关于我们' }
          ]
        }
      ]
    }
  },
  methods: {
    toPage (path) {
      this.$router.push(path)
      window.scrollTo(0, 0, 'smooth')
    },
    jumpLink (type) {
      const url = type === 'icp' ? 'https://beian.miit.gov.cn' : 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202010013'
      window.open(url)
    }
  }
}
</script>

<style lang='scss' scoped>
footer {
  background: url('https://images.zzt.com.cn/cdn_file/zst-official/footer_bg.png') no-repeat;
  background-color: #141A25;
  background-position: center center;
  background-size: cover;
  width: 100%;
  min-width: $container-width;
  height: Translate(380px);

  .content {
    display: flex;
    flex-direction: column;
    width: $container-width;
    height: 100%;
    margin: 0 auto;
    color: #fff;

    .top {
      display: flex;
      justify-content: space-between;
      text-align: left;
      height: Translate(323px);
      box-sizing: border-box;

      .left {
        display: flex;
        flex-direction: column;
        padding-top: Translate(64px);

        .title {
          @include Text(32px, 600, 45px, #111, 'PingFangSC-Semibold');
          @include GradientText();
        }

        .nav-box {
          display: flex;
          gap: Translate(58px);
          padding-top: Translate(21px);

          .nav-item {
            .nav-title {
              @include Text(16px, 500, 22px, #fff, 'PingFangSC-Medium');
            }

            .nav-child {
              display: flex;
              flex-direction: column;
              gap: Translate(12px);
              margin-top: Translate(18px);
              @include Text(14px, 400, 24px, #A2A3A7, 'PingFangSC-Regular');
            }
          }
        }

        .cursor-pointer {
          &:hover {
            color: #fff;
          }
        }
      }

      .right {
        display: flex;
        gap: Translate(24px);
        padding-top: Translate(122px);

        .code-item {
          height: Translate(144px);
          padding: Translate(14px) Translate(14px) 0;
          text-align: center;
          border: 1px solid #585D71;
          border-radius: Translate(4px);
          box-sizing: border-box;

          .img-box {
            display: block;
            padding: Translate(6px);
            background-color: #fff;
            border-radius: Translate(4px);
          }

          .code-text {
            padding-top: Translate(6px);
            @include Text(14px, 400, 20px, #fff, 'PingFangSC-Regular');
          }
        }
      }
    }

    .bottom {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #585D71;
      @include Text(14px, 400, 24px, #797B80, 'PingFangSC-Regular');

      .cursor-pointer {
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
